import React, { useEffect } from "react";
import Routes from "./Routes";
import { initAnalytics } from "lib/analytics";
import { ConfigProvider } from "./context/ConfigContext";

function App() {
  useEffect(() => {
    initAnalytics();
  }, []);

  return (
    <ConfigProvider>
      <Routes />
    </ConfigProvider>
  );
}

export default App;
